module.exports = __webpack_public_path__ + "files/815f1004ad07aad63602cf953f7c8a1a.png";